import React, { useState, useEffect, useContext } from "react";
import { toast } from "react-toastify";
import { logActivity } from "../../utils/LogActivity";
import { AuthContext } from "../../Context/AuthContext";
import { Authorization } from "../../Context/Authorization";

const inputStyle = { width: "100%", padding: "9px 12px", border: "1.5px solid #E2E8F0", borderRadius: 8, fontSize: 13, color: "#1A202C", background: "#fff", outline: "none", transition: "border-color 0.2s" };
const labelStyle = { fontSize: 12, fontWeight: 600, color: "#2D3748", marginBottom: 6, display: "block" };

const AddCircleForm = ({ onClose, onAddCircle }) => {
  const [circleName, setCircleName] = useState("");
  const [circleCode, setCircleCode] = useState("");
  const [stateId, setStateId] = useState("");
  const [states, setStates] = useState([]);
  const [errors, setErrors] = useState({});
  const Api = process.env.REACT_APP_API;
  const { userId } = useContext(AuthContext);

  useEffect(() => {
    const fetchStates = async () => {
      try {
        const config = Authorization();
        const response = await fetch(`${Api}/api/states`, config);
        const data = await response.json();
        setStates(data);
      } catch (error) {
        console.error("Error fetching states:", error);
      }
    };
    fetchStates();
  }, []);

  const validate = () => {
    const errs = {};
    if (!circleName) errs.circleName = "Circle name is required";
    if (!circleCode) errs.circleCode = "Circle code is required";
    if (!stateId) errs.stateId = "Please select a State";
    return errs;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) { setErrors(errs); toast.error("Please fill all details"); return; }

    try {
      const config = Authorization();
      const response = await fetch(`${Api}/api/circles`, {
        method: "POST",
        headers: { "Content-Type": "application/json", ...config.headers },
        body: JSON.stringify({ circleName, circleCode, stateId }),
      });
      if (response.ok) {
        const result = await response.json();
        toast.success("Added Successfully");
        onAddCircle(result);
        await logActivity(userId, "Added New Circle", "Circle Page", Api);
        onClose();
      } else {
        toast.error("Error submitting form");
      }
    } catch {
      toast.error("Error submitting form");
    }
  };

  const focus = (e) => (e.target.style.borderColor = "#4CAF50");
  const blur = (e) => (e.target.style.borderColor = "#E2E8F0");

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1050, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div style={{ background: "#fff", borderRadius: 12, width: "100%", maxWidth: 460, boxShadow: "0 20px 60px rgba(0,0,0,0.3)", overflow: "hidden" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 20px", background: "linear-gradient(135deg,#1B5E20,#2E7D32)" }}>
          <span style={{ fontSize: 14, fontWeight: 700, color: "#fff" }}>Add Circle</span>
          <button onClick={onClose} style={{ background: "rgba(255,255,255,0.2)", border: "none", borderRadius: 6, color: "#fff", cursor: "pointer", fontSize: 16, width: 28, height: 28, display: "flex", alignItems: "center", justifyContent: "center" }}>✕</button>
        </div>
        <div style={{ padding: 24 }}>
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 16 }}>
              <label style={labelStyle}>Circle Name <span style={{ color: "#E53E3E" }}>*</span></label>
              <input type="text" placeholder="Enter circle name" value={circleName}
                onChange={(e) => setCircleName(e.target.value)} style={inputStyle} onFocus={focus} onBlur={blur} />
              {errors.circleName && <div style={{ color: "#E53E3E", fontSize: 11, marginTop: 4 }}>{errors.circleName}</div>}
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={labelStyle}>Circle Code <span style={{ color: "#E53E3E" }}>*</span></label>
              <input type="text" placeholder="Enter circle code" value={circleCode}
                onChange={(e) => setCircleCode(e.target.value)} style={inputStyle} onFocus={focus} onBlur={blur} />
              {errors.circleCode && <div style={{ color: "#E53E3E", fontSize: 11, marginTop: 4 }}>{errors.circleCode}</div>}
            </div>
            <div style={{ marginBottom: 20 }}>
              <label style={labelStyle}>State <span style={{ color: "#E53E3E" }}>*</span></label>
              <select value={stateId} onChange={(e) => setStateId(e.target.value)}
                style={{ ...inputStyle, cursor: "pointer" }} onFocus={focus} onBlur={blur}>
                <option value="">Select State</option>
                {states.map((state) => (
                  <option key={state._id} value={state._id}>{state.stateName} ({state.stateCode})</option>
                ))}
              </select>
              {errors.stateId && <div style={{ color: "#E53E3E", fontSize: 11, marginTop: 4 }}>{errors.stateId}</div>}
            </div>
            <div style={{ display: "flex", gap: 10 }}>
              <button type="submit" style={{ display: "inline-flex", alignItems: "center", gap: 7, padding: "10px 20px", background: "linear-gradient(135deg,#1B5E20,#2E7D32)", color: "#fff", border: "none", borderRadius: 9, fontSize: 13, fontWeight: 700, cursor: "pointer", boxShadow: "0 3px 10px rgba(46,125,50,0.3)" }}>
                <i className="mdi mdi-check" /> Submit
              </button>
              <button type="button" onClick={onClose} style={{ padding: "10px 20px", background: "#F7FAFC", color: "#4A5568", border: "1px solid #E2E8F0", borderRadius: 9, fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddCircleForm;
